const article = {
  id: "testirovshchiki-ili-tehnicheskie-agenty",
  metaTitle: "Тестировщики или технические агенты: что выбрать | Boostclick",
  metaDescription: "Чем сценарий живого тестировщика отличается от последовательности технического агента: глубина действий, отчётность, цена и задачи, под которые подходит каждый.",
  type: "Гайд",
  category: "Поисковые системы",
  title: "Тестировщики и технические агенты: что выбрать",
  time: 6,
  data: "31.07.2026",
  imageUrl: "/blogImages/testirovshchiki-ili-tehnicheskie-agenty/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Разбор двух инструментов без деления на «правильный» и
  «неправильный»: что реально делает технический агент, что делает живой
  тестировщик, чем отличаются их отчёты и как сравнивать цену, когда у одного
  в стоимость входит действие, а у другого — весь сценарий целиком.`,
  navigation: [
    { to: "dva-instrumenta", text: "Два инструмента, а не два лагеря" },
    { to: "chto-delaet-agent", text: "Что делает технический агент" },
    { to: "chto-delaet-testirovshchik", text: "Что делает тестировщик" },
    { to: "v-chem-raznica", text: "В чём разница на практике" },
    { to: "kogda-chto", text: "Когда что уместно" },
    { to: "kak-sravnivat-cenu", text: "Как сравнивать цену" },
    { to: "chto-sprosit", text: "Что спросить до оплаты" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "dva-instrumenta",
      title: "Два инструмента, а не два лагеря",
      content: [
        {
          type: "Description",
          text: "Спор «люди против ботов» обычно ведут так, будто один вариант честный, а другой нет. На практике это два разных инструмента с разной ценой и разными ограничениями, и выбор между ними — это выбор задачи, а не выбор стороны.",
        },
        {
          type: "Description",
          text: "Разница сводится к одному: кто именно выполняет действие. В первом случае — программа, которая идёт по заданной логике. Во втором — человек, который получил задание, открыл свой браузер и сделал то, что там написано. Всё остальное — следствия.",
        },
      ],
    },
    {
      id: "chto-delaet-agent",
      title: "Что делает технический агент",
      content: [
        {
          type: "Description",
          text: "Технический агент — это программа, которая выполняет заданную последовательность: открыть адрес, дождаться загрузки, прокрутить, перейти по ссылке, закрыть. Последовательность задаётся заранее и повторяется столько раз, сколько нужно.",
        },
        {
          type: "Description",
          text: "Сильные стороны очевидны: это дёшево, быстро и масштабируется без предела. Тысяча выполнений стоит примерно как тысяча выполнений, а не как тысяча человеко-часов.",
        },
        {
          type: "Description",
          text: "Ограничения тоже понятные. Набор действий беднее: агент проходит базовый путь, но не изучает каталог тридцать секунд, потому что ему стало интересно. Среда выполнения однороднее, чем у живых посетителей. И отчёта, который можно сверить со своей статистикой, обычно нет — есть только счётчик выполнений.",
        },
      ],
    },
    {
      id: "chto-delaet-testirovshchik",
      title: "Что делает живой тестировщик",
      content: [
        {
          type: "Description",
          text: "Тестировщик получает текстовое задание — что найти, что посмотреть, сколько времени провести — и выполняет его со своего устройства, из своего города, в удобное себе время.",
        },
        {
          type: "Description",
          text: "Сценарий поэтому длиннее и разнообразнее: поиск по фразе, просмотр нескольких результатов выдачи, переход, изучение разделов, просмотр контактов. Каждое такое действие человек делает так, как ему удобно, — с паузами, возвратами и собственным темпом.",
        },
        {
          type: "Description",
          text: "Главное следствие — отчётность. Исполнитель указывает время начала и конца сессии, и это можно сверить с записями Вебвизора и с отчётами Метрики. Проверяемость здесь важнее, чем сам факт «живого» выполнения: она превращает услугу в то, что можно принять или отклонить.",
        },
      ],
    },
    {
      id: "v-chem-raznica",
      title: "В чём разница на практике",
      content: [
        {
          type: "Subtotal",
          title: "Одна задача — два способа выполнения",
          text: "Сравнение по параметрам, которые видно со стороны заказчика.",
          blocks: {
            block1: [
              {
                type: "List",
                listType: "ul",
                blockTitle: "Технические агенты:",
                items: [
                  { text: "выполняет программа по заданной логике", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "цена за действие ниже в разы", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "набор действий базовый", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "среда выполнения однородная", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "отчёта с временем сессии нет", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "объём наращивается мгновенно", style: { fontSize: "18px", lineHeight: "140%" } },
                ],
              },
            ],
            block2: [
              {
                type: "List",
                listType: "ul",
                blockTitle: "Живые тестировщики:",
                items: [
                  { text: "выполняет человек со своего устройства", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "цена за действие выше", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "полный сценарий, включая изучение каталога", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "устройства, сети и время естественно разные", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "отчёт с временем начала и конца сессии", style: { fontSize: "18px", lineHeight: "140%" } },
                  { text: "объём ограничен числом свободных исполнителей", style: { fontSize: "18px", lineHeight: "140%" } },
                ],
              },
            ],
          },
        },
        {
          type: "Description",
          text: "Обратите внимание, что в этом списке нет строки «эффект». Ни один добросовестный подрядчик не назовёт вам ожидаемый прирост позиций — он зависит от состояния сайта, конкуренции в тематике и алгоритмов, а не от способа выполнения задания.",
        },
      ],
    },
    {
      id: "kogda-chto",
      title: "Когда что уместно",
      content: [
        {
          type: "Subtotal",
          title: "Живые исполнители",
          text: "Когда важна глубина сценария и проверяемость: старт работы, коммерческие запросы, ситуации, где нужно потом разобрать, что именно происходило на сайте. Это же выбор по умолчанию, если вы делаете это впервые и хотите сначала посмотреть на отчёты.",
        },
        {
          type: "Subtotal",
          title: "Технические агенты",
          text: "Когда сценарии с людьми уже идут, база собрана, и нужно нарастить объём при ограниченном бюджете. Как дополнение — работают; как единственный инструмент на старте — дают вам цифру и почти ничего, что можно проверить.",
        },
        {
          type: "Description",
          parts: [
            "Оба тарифа переключаются в калькуляторе на одной и той же странице, отдельный проект заводить не нужно: ",
            { to: "/nakrutka-pf-yandex", text: "сценарии с реальными людьми" },
            " и ",
            { to: "/nakrutka-pf-yandex-bots", text: "тариф с техническими агентами" },
            ".",
          ],
        },
      ],
    },
    {
      id: "kak-sravnivat-cenu",
      title: "Как сравнивать цену",
      content: [
        {
          type: "Description",
          text: "Цена за действие — самый неудобный способ сравнения, потому что «действие» у всех разное. У одного подрядчика в него входит переход по ссылке, у другого — поиск по фразе, просмотр соседних результатов, переход, три минуты на сайте и просмотр контактов.",
        },
        {
          type: "Description",
          text: "Считайте иначе: возьмите итоговую сумму проекта и разделите её на число завершённых сценариев. Эту цифру и сравнивайте между подрядчиками — она учитывает и длину сценария, и то, что часть заданий может быть отклонена.",
        },
        {
          type: "Footnote",
          textItalic: "Второй множитель, о котором забывают, — срок. Одно и то же число заданий, разложенное на пять дней, стоит дешевле, чем то же самое за сутки: задания спокойно расходятся по свободным исполнителям.",
        },
      ],
    },
    {
      id: "chto-sprosit",
      title: "Что спросить до оплаты",
      content: [
        {
          type: "Description",
          text: "Пять вопросов, ответы на которые отличают подрядчика, с которым можно работать, от продавца цифр.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Что именно входит в одно выполнение? ", text: "Список действий целиком, а не «визит»." },
            { bold: "Что я получу как подтверждение? ", text: "Отчёт с временем сессии, который можно сверить со своей статистикой, — или только число в личном кабинете." },
            { bold: "Когда я плачу? ", text: "До выполнения или после приёмки отчётов. Возможность отклонить некорректное выполнение — это и есть механизм качества." },
            { bold: "Нужен ли доступ к сайту, счётчикам или рекламному кабинету? ", text: "Для сценариев со стороны посетителя доступ не нужен. Требование доступа — повод задуматься." },
            { bold: "Что вы обещаете по результату? ", text: "Правильный ответ — ничего конкретного по позициям. Обещание топа к дате означает, что вам продают то, чем подрядчик не управляет." },
          ],
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "Разница не в «честности», а в том, кто выполняет действие и что вы можете проверить." },
            { text: "Технический агент — дёшево, быстро, без отчёта и с базовым набором действий." },
            { text: "Живой тестировщик — дороже, сценарий длиннее, есть отчёт с временем сессии." },
            { text: "Сравнивайте не цену действия, а сумму проекта, делённую на число завершённых сценариев." },
            { text: "Начинать логично с людей, добирать объём агентами — не наоборот." },
            { text: "Подрядчик, который обещает позиции к дате, продаёт то, чем не управляет." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
